<template>
  <div>
    <transition mode="out-in">

      <div v-if="isAuthenticated" class="d-grid col-md-8 col-lg-6 mx-auto">
        <div v-if="hasAccess && isEshop === false">
          <h1>Connect Your Store</h1>
          <ebay-callback :importable="true" />
        </div>

        <coming-soon v-else />
      </div>
      <welcome v-else />
    </transition>
  </div>
</template>

<script setup>
import { computed, watch } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import EbayCallback from "@/app/views/EbayCallback.vue";
import Welcome from "@/app/views/Welcome.vue";
import ComingSoon from "@/app/components/Utils/ComingSoon.vue";
const store = useStore()
const router = useRouter()
const isAuthenticated = computed(() => !!store.state.user)
const eshop = computed(() => store.state.eshop.eshop)
const isEshop = computed(() => !!eshop.value && eshop.value.status === 'ACTIVE')
const hasAccess = computed(() => store.getters.hasAccess)

if (isEshop.value === true) {
  router.replace({name: 'Insights', params: {storeKey: eshop.value.id}})
}

watch(isAuthenticated, (newVal) => {
  if (newVal) {
    router.replace({name: 'Home'})
  }
})

watch(eshop, (newVal) => {
  router.replace({name: 'Insights', params: {storeKey: newVal.id}})
})
</script>

<style scoped>
.home-content {
  width: 500px; max-width: 100%;
}
</style>
